module.exports = __webpack_public_path__ + "media/components/icons/SVG/settings-6bcc9c3c44c60593f6d96a2b9c865d53.svg";